import dataServices from '@/shared/api/dataServices';
// import { set } from 'lodash';

import {
  GET_DRIVER
} from '../mutation-types';

export const state = () => ({
  driver: {}
});

const mutations = {
  [GET_DRIVER](state, driverData) {
    state.driver = driverData;
  }
};

const actions = {
  async getDriverDataAction({ commit }) {
    const driverData = await dataServices.getHomeData();
    commit(GET_DRIVER, driverData);
  }
};

const getters = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
